import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-survey-detail',
  templateUrl: './survey-detail.component.html',
  styleUrls: ['./survey-detail.component.scss']
})
export class SurveyDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
